<template>
	<v-container fluid tag="section">
		<v-form ref="form" v-model="valid" lazy-validation autocomplete="new-password">
			<ti-card :icon="$icons.diploma">
				<template #title><span>{{ isEdit ? 'Edit' : 'New' }}</span> Diploma</template>
				<template #title-actions-shown>
					<v-btn color="success" elevation="2" fab small class="mr-4" @click="save">
						<v-icon>{{ $icons.save }}</v-icon>
					</v-btn>
				</template>
				<template #title-actions-hidden>
					<ti-confirm @confirm="destroy" message="Are you sure you want to delete this course?" button-text="Delete">
						<v-btn color="error" elevation="2" fab small class="mr-4">
							<v-icon>{{ $icons.delete }}</v-icon>
						</v-btn>
					</ti-confirm>
				</template>
				<ti-form-layout>
					<template #sidebar>
						<v-col cols="12">
							<v-select v-model="diploma.brand_id" :items="brands" item-text="name" item-value="id" label="Brand"></v-select>
						</v-col>
<!--						<v-col cols="12">-->
<!--							<v-text-field type="number" v-model="diploma.completion_percent" min="0" max="100" label="Completion percentage requirement"></v-text-field>-->
<!--						</v-col>-->
					</template>
					<template>
						<v-col cols="12">
							<v-text-field v-model="diploma.name" :rules="validations.name" label="Name"></v-text-field>
						</v-col>
					</template>
				</ti-form-layout>
			</ti-card>

			<ti-card class="mt-5">
				<template #title>Submission dates</template>
				<template #title-actions-shown>
					<v-btn color="success" elevation="2" fab small class="mr-4" @click="addSubmissionDate">
						<v-icon>{{ $icons.plus }}</v-icon>
					</v-btn>
				</template>
				<v-card-text>
					<v-row v-for="(certification_submission_date, index) in diploma.certification_submission_dates_attributes" :key="certification_submission_date.id" v-if="!certification_submission_date._destroy">
						<v-col cols="auto" class="d-flex align-center">
							<ti-date-picker v-model="certification_submission_date.expression_of_interest" label="Expression of interest"></ti-date-picker>
						</v-col>
						<v-col cols="auto" class="d-flex align-center">
							<ti-date-picker v-model="certification_submission_date.full_plan" label="Full plan"></ti-date-picker>
						</v-col>
						<v-col cols="auto" class="d-flex align-center">
							<ti-date-picker v-model="certification_submission_date.final_draft" label="Final draft"></ti-date-picker>
						</v-col>
						<v-col cols="auto" class="d-flex align-center">
							<ti-date-picker v-model="certification_submission_date.cim_submission" label="CIM Submission"></ti-date-picker>
						</v-col>
						<v-col cols="auto" class="d-flex align-center">
							<v-btn icon color="error" @click="removeSubmissionDate(index)">
								<v-icon>{{ $icons.delete }}</v-icon>
							</v-btn>
						</v-col>
					</v-row>
				</v-card-text>
			</ti-card>

			<ti-card class="mt-5">
				<template #title>Resources</template>
				<template #title-actions-shown>
					<v-btn color="success" elevation="2" fab small class="mr-4" @click="openAddDialog">
						<v-icon>{{ $icons.plus }}</v-icon>
					</v-btn>
				</template>
				<v-card-text>
					<v-row v-for="(certification_resource, index) in diploma_resources_ordered" :key="certification_resource.id">
						<v-col cols="1" class="d-flex align-center">
							<span>{{ certification_resource.order }}</span>
						</v-col>
						<v-col cols="2" class="grow d-flex align-center">
							<p class="ma-0 text--black"> {{ certification_resource.section }}</p>
						</v-col>
						<v-col cols="2" class="grow d-flex align-center">
							<p class="ma-0 text--black"> {{ getBrandName(brands, certification_resource.brand_id) }}</p>
						</v-col>
						<v-col cols="5" class="grow d-flex align-center">
							<p class="ma-0 text--black"> {{ getResourceName(certification_resource) }} - {{ getResourceType(certification_resource) }}</p>
						</v-col>
						<v-col cols="2" class="d-flex align-center">
							<v-btn icon @click="certificationResourceOrderUp(certification_resource, index)">
								<v-icon>{{ $icons.up }}</v-icon>
							</v-btn>
							<v-btn icon @click="certificationResourceOrderDown(certification_resource, index)">
								<v-icon>{{ $icons.down }}</v-icon>
							</v-btn>
							<v-btn icon color="error" @click="destroyResource(certification_resource, index)">
								<v-icon>{{ $icons.delete }}</v-icon>
							</v-btn>
						</v-col>
					</v-row>
				</v-card-text>
			</ti-card>
		</v-form>


		<v-dialog v-model="addDialog" persistent max-width="800px">
			<v-card>
				<v-card-title>
					<span class="text-h5">Add resource</span>
				</v-card-title>
				<v-card-text>
					<v-container>
						<v-row>
							<v-col cols="12">
								<v-autocomplete
									v-model="newResource.resource_id"
									:items="resources_for_select"
									:item-text="(item) => `${item.title} - ${item.brand} - ${expertiseLabel(item.expertise)}`"
									:item-value="(item) => item.id"
									label="Select resource"
								></v-autocomplete>
							</v-col>
							<v-col cols="12">
								<v-combobox
									v-model="newResource.section"
									label="Section"
									:items="sections"
								></v-combobox>
							</v-col>
						</v-row>
					</v-container>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="secondary" text @click="addDialog = false">Close</v-btn>
					<v-btn color="success" @click="addResource">Add</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-container>
</template>
<script>

import validationRules from "@/util/validation";
import {sync} from "vuex-pathify";
import helperMixin from "@/mixins/helperMixin";
import TiForm from "./Form"
import {arrayMoveMutable} from "array-move";
import models from '@/models'
import _find from "lodash/find";
import _uniqBy from 'lodash/uniqBy'
import TiDatePicker from "../../../components/TiDatePicker";

export default {
	name: "DiplomasForm",
	props: ['id'],
	mixins: [helperMixin],
	components: {TiDatePicker, TiForm},
	computed: {
		isEdit() {
			return this.$route.meta?.edit
		},
		diploma: sync('diplomas/diploma'),
		brands: sync('brands/brands'),
		resources: sync('resources/resources'),
		resources_for_select(){
			return this.resources.filter((r) => (r.brand_id === null || r.brand_id === this.diploma.brand_id)).sort((a, b) => a?.title - b?.title);
		},
		diploma_resources_ordered() {
			if (this.diploma?.certification_resources_attributes.length < 1) return [];
			return this.diploma.certification_resources_attributes.filter((a) => !a._destroy).sort((a, b) => a?.order - b?.order);
		},
		sections(){
			return _uniqBy(this.diploma?.certification_resources_attributes.map(i => i.section), item => item)
		}
	},
	data: () => ({
		valid: false,
		addDialog: false,
		validations: {
			name: validationRules('Name', ['required', 'minLength:2']),
		},
		newResource: models.Certification().certification_resources_attributes[0]
	}),
	beforeMount() {
		this.init()
	},
	methods: {
		init() {
			this.$store.set('brands/getBrands!', null)
			this.$store.set('resources/getResources!', null)
			if (this.isEdit) {
				this.$store.set('diplomas/getDiploma!', this.id)
			} else {
				this.diploma = models.Certification('Diploma')
				this.diploma.certification_resources_attributes = []
			}
		},
		getDiploma(id) {
			this.$api.diplomas.show(id)
				.then(response => this.diploma = response.data)
				.catch(error => this.$toast.add(error.message, 'error'))
		},
		getResourceName(certification_resource) {
			return _find(this.resources, function (o) {
				return o.id === certification_resource.resource_id
			})?.title
		},
		getResourceType(certification_resource) {
			return _find(this.resources, function (o) {
				return o.id === certification_resource.resource_id
			})?.type
		},
		addSubmissionDate(){
			this.diploma.certification_submission_dates_attributes.push(models.CertificationSubmissionDate())
		},
		removeSubmissionDate(index){
			this.diploma.certification_submission_dates_attributes[index]._destroy = true
		},
		save() {
			if (this.$refs.form.validate()) {
				if (this.isEdit) {
					console.log(this.diploma.certification_resources_attributes);
					this.$api.diplomas.update(this.id, this.diploma)
						.then(response => {
							this.$toast.add('Diploma updated successfully', 'success')
							this.$route.meta.disableWarn = true;
							this.$router.push({name: 'Diplomas'})
						})
						.catch(error => {
							console.log(error.response);
							this.$toast.add(error.response.statusText, 'error')
						})
				} else {
					this.$api.diplomas.create(this.diploma)
						.then(response => {
							this.$toast.add('Diploma created successfully', 'success')
							this.$route.meta.disableWarn = true;
							this.$router.push({name: 'Diplomas'})
						})
						.catch(error => {
							console.log(error.response);
							this.$toast.add(error.response.statusText, 'error')
						})
				}

			} else {
				this.$toast.add('Please fix validation errors', 'error')
			}
		},
		destroy() {
			this.$api.diplomas.delete(this.id, this.diploma)
				.then(response => {
					this.$toast.add('Diploma deleted successfully', 'success')
					this.$route.meta.disableWarn = true;
					this.$router.push({name: 'Diplomas'})
				})
				.catch(error => {
					console.log(error.response);
					this.$toast.add(error.response.statusText, 'error')
				})
		},
		openAddDialog() {
			this.addDialog = true;
			this.resetNewStep()
		},
		addResource() {
			// console.log(this.diploma.certification_resources_attributes);
			this.newResource.order = this.diploma.certification_resources_attributes.length + 1
			this.diploma.certification_resources_attributes.push(this.newResource)
			this.addDialog = false
		},
		resetNewStep() {
			this.newResource = models.Certification().certification_resources_attributes[0]
		},
		certificationResourceOrderUp(certification_resource, index) {
			if (certification_resource.order === 1) return;
			arrayMoveMutable(this.diploma.certification_resources_attributes, index, index - 1);
			this.reorderCertificationResources();
		},
		certificationResourceOrderDown(certification_resource, index) {
			if (certification_resource.order === this.diploma.certification_resources_attributes.length) return;
			console.log('moving');
			arrayMoveMutable(this.diploma.certification_resources_attributes, index, index + 1);
			this.reorderCertificationResources();
		},
		destroyResource(step, index) {
			this.diploma.certification_resources_attributes[index]['_destroy'] = true;
			arrayMoveMutable(this.diploma.certification_resources_attributes, index, -1);
			this.reorderCertificationResources();
		},
		reorderCertificationResources() {
			this.diploma.certification_resources_attributes.map((step, index) => step.order = index + 1)
		},
	}
}
</script>